import { TFunction } from "@impero-com/common/utils/i18n";
import { assertNever } from "@impero-com/common/utils/obj";

import { TimePeriod } from "api/generated/model";

export type TimePeriodKind = TimePeriod["type"];

/** The periods offered by {@link TimeFilter}, in display order. */
export const TIME_PERIOD_KINDS: TimePeriodKind[] = [
    "CurrentWeek",
    "PreviousWeek",
    "CurrentMonth",
    "PreviousMonth",
    "CurrentQuarter",
    "PreviousQuarter",
    "CurrentYear",
    "PreviousYear",
    "Custom",
];

export function localizeTimePeriod(kind: TimePeriodKind, t: TFunction): string {
    switch (kind) {
        case "CurrentWeek":
            return t("CoveredPeriod_0_Week");
        case "PreviousWeek":
            return t("CoveredPeriod_1_Week");
        case "CurrentMonth":
            return t("CoveredPeriod_0_Month");
        case "PreviousMonth":
            return t("CoveredPeriod_1_Month");
        case "CurrentQuarter":
            return t("CoveredPeriod_0_Quarter");
        case "PreviousQuarter":
            return t("CoveredPeriod_1_Quarter");
        case "CurrentYear":
            return t("CoveredPeriod_0_Year");
        case "PreviousYear":
            return t("CoveredPeriod_1_Year");
        case "Custom":
            return t("Dashboard_TimeFilter_CustomDueDate");
        default:
            return assertNever(kind);
    }
}
